// frontend/src/AppMUI.js
import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Root from './Root';
import { useDispatch } from 'react-redux';
import { setTheme } from './slices/modeSlice';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon'


const mode = localStorage.getItem('mode')
  ? JSON.parse(localStorage.getItem('mode'))
  : { theme: 'light' };
let defaulTheme = 'light';
if (mode?.theme) {
  defaulTheme = mode.theme;
}

const AppMUI = () => {
  const [mode, setMode] = React.useState(defaulTheme);
  const dispatch = useDispatch();

  const toggleColorMode = () => {
    setMode((prevMode) => {
      const res = prevMode === 'light' ? 'dark' : 'light';
      dispatch(setTheme(res));
      return res;
    });
  };

  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          mode,
        },
      }),
    [mode]
  );
  return (
    <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale="ru">
      <ThemeProvider theme={theme}>
        <Root toggleColorMode={toggleColorMode} />
      </ThemeProvider>
    </LocalizationProvider>
  );
};

export default AppMUI;
